module.exports = __webpack_public_path__ + "b2262eb91a6cb7cf636a77b684570da9.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/icon-arrow.png
// module id = 388
// module chunks = 0